import { createFileRoute } from '@tanstack/react-router'
import MyTasksPage from '@/pages/tasks/my-tasks'

export const Route = createFileRoute('/(protected)/tasks/')({
  component: MyTasksPage,
})

